import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type { RootState } from '../../../store';
import type { I2FAInitiol, Legacy2faData } from './types';

const initialState: I2FAInitiol = {
  legacy2faData: null,
  email: '',
  password: '',
  error: false,
};

const login2FASlice = createSlice({
  name: 'login2fa',
  initialState,
  reducers: {
    setLegacy2faData: (state, action: PayloadAction<Legacy2faData>) => {
      state.legacy2faData = action.payload;
    },
    setEmail: (state, action: PayloadAction<string>) => {
      state.email = action.payload;
    },
    setPassword: (state, action: PayloadAction<string>) => {
      state.password = action.payload;
    },
    setIsError: (state, action: PayloadAction<boolean>) => {
      state.error = action.payload;
    },
  },
});

export const { setLegacy2faData, setEmail, setPassword, setIsError } = login2FASlice.actions;

export const selectLegacy2faData = (state: RootState) => state.auth2f.legacy2faData;
export const selectEmail = (state: RootState) => state.auth2f.email;
export const selectPassword = (state: RootState) => state.auth2f.password;
export const select2faError = (state: RootState) => state.auth2f.error;

export default login2FASlice.reducer;
